import React from "react"
import _ from "lodash"

import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import store from '../../Redux';
import { doPost, doLoad, doPut, select, doDelete } from '../../Redux/Actions'

import Master from '../../Components/Master';
import LoaderButton from '../../Components/LoaderButton';
import Loader from '../../Components/Loader';
import { TextFieldHelper, SelectFieldWrapper } from '../../Components/Fields';
import DatePickerContainer from '../../Components/DatePickerContainer';

import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import Divider from '@material-ui/core/Divider';

import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';


const styles = theme => ({
    card: {
        width: "100%"
    },
    flex: {
        flex: 1
    },
    divider: {
        marginTop: 20,
        marginBottom: 20,
        marginLeft: -30,
        marginRight: -30,
    }
})

class FuhrparkDetail extends Master {

    state = {
        newEntry: {},
        putLoading: false,
        isLoading: true
    }

    componentDidMount() {
        this.props.doLoad(this.props.match.params.id)

        this.unsubscribe = store.subscribe(() => {
                var fuhrpark = select(store.getState(), "fuhrpark")

                if(this.state.newEntry.id === undefined) {
                    this.setState({
                        newEntry: fuhrpark.data
                    })
                }

                if(this.state.isLoading) {
                    this.setState({
                        isLoading: fuhrpark.isLoading
                    })
                }

                if(_.has(fuhrpark, "putLoading") && this.state.putLoading !== fuhrpark.putLoading) {
                    if(_.has(fuhrpark.putLoading, this.state.newEntry.id)) {
                        this.setState({
                            putLoading: fuhrpark.putLoading[this.state.newEntry.id]
                        })
                    }

                }
            }
        )

    }

    componentWillUnmount() {
        this.unsubscribe()
    }

    /*handleChange = name => event => {
        //this.state[name] = event.target.value

        var val = ""
        if(event._d !== undefined) {
            val = event._d
        } else {
            val = event.target.value
            if(event.target.type === "checkbox") {
                val = event.target.checked
            }
        }

        this.state.newEntry[name] = val

        this.setState({
            newEntry: this.state.newEntry
        });

    }*/

    saveAction = () => {
        this.props.doPut(this.state.newEntry.id, this.state.newEntry)
    }

    render() {

        const { classes } = this.props;

        var {
            aktiv,
            match,
            marke,
            kennzeichen,
            fin,
            handelsbezeichnung,
            handelsbezeichnung_kurz,
            eigengewicht,
            tech_zul_gesamtmasse,
            gesamtgewicht,
            sitzplaetze,
            stehplaetze,
            erstmalige_zugelassung,
            zugelassen,
            leistung_kw,
            leistung_ps,
            hubraum,
            abgasnorm,
            bereifung_achse1,
            bereifung_achse2,
            bereifung_achse3,
            felge_achse1,
            felge_achse2,
            felge_achse3,
            zulassungstelle,
            zulassungsbesitzer,
            paragraph57,
            feuerloescher,
            tueren,
            rollstuhlrampe,
            dld,
            tacho,
            tachoversion,
            kuehlerfrostschutz,
            farbe,
            wartungsvertrag,
            wv_von,
            wv_bis,
            km_gesamt,
            km_pro_jahr,
            km_pro_monat,
            wv_stand,
            notiz
        } = this.state.newEntry

        var {
            isLoading
        } = this.state

        if(isLoading) {
            return (
                <Loader />
            )
        }

        var name = []
        if(marke) {
            name.push(marke)
        }
        if(kennzeichen) {
            name.push(<b>&nbsp;{kennzeichen}</b>)
        }

        return (
            <div>
                <Toolbar>
                    <IconButton onClick={() => this.props.history.push("/fuhrpark")} aria-label="Back">
                        <ArrowBackIcon />
                    </IconButton>
                    {name}
                    <div className={classes.flex} />
                    <IconButton aria-label="Delete">
                        <DeleteForeverIcon />
                    </IconButton>
                </Toolbar>
                <Card className={classes.card}>
                    <CardContent>

                        <Grid container spacing={8}>

                            <TextFieldHelper n={2} value={match} onChange={this.handleChange('match')} label="Matchcode" />
                            <TextFieldHelper n={2} value={marke} onChange={this.handleChange('marke')} label="Marke" />
                            <TextFieldHelper n={4} value={kennzeichen} onChange={this.handleChange('kennzeichen')} label="Kennzeichen" />
                            <TextFieldHelper n={4} value={fin} onChange={this.handleChange('fin')} label="FIN" />

                        </Grid>

                        <Divider className={"divider"} />

                        <Grid container spacing={8}>
                            <Grid item xs={3}>
                                <DatePickerContainer
                                    name="erstmalige_zugelassung"
                                    label="Erstmalige Zugelassung"
                                    value={erstmalige_zugelassung}
                                    onChange={this.handleChange('erstmalige_zugelassung')}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <DatePickerContainer
                                    label="Zugelassen"
                                    value={zugelassen}
                                    name="zugelassen"
                                    onChange={this.handleChange('zugelassen')}
                                />
                            </Grid>
                        </Grid>

                        <Divider className={"divider"} />

                        <Grid container spacing={8}>

                            <TextFieldHelper n={6} value={handelsbezeichnung} onChange={this.handleChange('handelsbezeichnung')} label="Handelsbezeichnung" />
                            <TextFieldHelper n={6} value={handelsbezeichnung_kurz} onChange={this.handleChange('handelsbezeichnung_kurz')} label="Handelsbezeichnung Kurz" />

                            <TextFieldHelper n={4} type="number" value={eigengewicht} onChange={this.handleChange('eigengewicht')} label="Eigengewicht" />
                            <TextFieldHelper n={4} type="number" value={tech_zul_gesamtmasse} onChange={this.handleChange('tech_zul_gesamtmasse')} label="Tech. zul. Gesamtmasse" />
                            <TextFieldHelper n={4} type="number" value={gesamtgewicht} onChange={this.handleChange('gesamtgewicht')} label="Gesamtgewicht" />

                        </Grid>

                        <Divider className={"divider"} />

                        <Grid container spacing={8}>

                            <TextFieldHelper n={2} type="number" value={sitzplaetze} onChange={this.handleChange('sitzplaetze')} label="Sitzplätze" />
                            <TextFieldHelper n={2} type="number" value={stehplaetze} onChange={this.handleChange('stehplaetze')} label="Stehplaetze" />

                        </Grid>

                        <Divider className={"divider"} />

                        <Grid container spacing={8}>

                            <TextFieldHelper n={3} type="number" value={leistung_kw} onChange={this.handleChange('leistung_kw')} label="Leistung in KW" />
                            <TextFieldHelper n={3} type="number" value={leistung_ps} onChange={this.handleChange('leistung_ps')} label="Leistung in PS" />
                            <TextFieldHelper n={3} type="number" value={hubraum} onChange={this.handleChange('hubraum')} label="Hubraum" />
                            <TextFieldHelper n={3} value={abgasnorm} onChange={this.handleChange('abgasnorm')} label="Abgasnorm" />

                        </Grid>

                        <Divider className={"divider"} />

                        <Grid container spacing={8}>

                            <Grid item xs={4}><small>Achse 1</small></Grid>
                            <Grid item xs={4}><small>Achse 2</small></Grid>
                            <Grid item xs={4}><small>Achse 3</small></Grid>

                            <TextFieldHelper n={4} value={bereifung_achse1} onChange={this.handleChange('bereifung_achse1')} label="Reifen" />
                            <TextFieldHelper n={4} value={bereifung_achse2} onChange={this.handleChange('bereifung_achse2')} label="Reifen" />
                            <TextFieldHelper n={4} value={bereifung_achse3} onChange={this.handleChange('bereifung_achse3')} label="Reifen" />

                            <TextFieldHelper n={4} value={felge_achse1} onChange={this.handleChange('felge_achse1')} label="Felgen" />
                            <TextFieldHelper n={4} value={felge_achse2} onChange={this.handleChange('felge_achse2')} label="Felgen" />
                            <TextFieldHelper n={4} value={felge_achse3} onChange={this.handleChange('felge_achse3')} label="Felgen" />

                        </Grid>

                        <Divider className={"divider"} />

                        <Grid container spacing={8}>
                            <TextFieldHelper n={6} value={zulassungstelle} onChange={this.handleChange('zulassungstelle')} label="Zulassungstelle" />
                            <TextFieldHelper n={6} value={zulassungsbesitzer} onChange={this.handleChange('zulassungsbesitzer')} label="Zulassungsbesitzer" />
                        </Grid>

                        <Divider className={"divider"} />

                        <Grid container spacing={8}>
                            <Grid item xs={3}>
                                <DatePickerContainer
                                    label="§57 Prüfung"
                                    value={paragraph57}
                                    name="paragraph57"
                                    onChange={this.handleChange('paragraph57')}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <DatePickerContainer
                                    label="Feuerlöscher"
                                    value={feuerloescher}
                                    name="feuerloescher"
                                    onChange={this.handleChange('feuerloescher')}
                                />
                            </Grid>
                        </Grid>

                        <Divider className={"divider"} />

                        <Grid container spacing={8}>
                            <TextFieldHelper n={3} value={tueren} onChange={this.handleChange('tueren')} label="Türen" />
                            <Grid item xs={3}>
                                <Switch
                                    key={rollstuhlrampe+"rollstuhlrampe"}
                                    checked={rollstuhlrampe}
                                    onChange={this.handleChange('rollstuhlrampe')}
                                    value="rollstuhlrampe"
                                /> Rollstuhlrampe
                            </Grid>
                            <Grid item xs={3}>
                                <Switch
                                    key={dld+"dld"}
                                    checked={dld}
                                    onChange={this.handleChange('dld')}
                                    value="dld"
                                /> Dld
                            </Grid>
                        </Grid>

                        <Divider className={"divider"} />

                        <Grid container spacing={8}>
                            <TextFieldHelper n={3} value={tacho} onChange={this.handleChange('tacho')} label="Tacho" />
                            <TextFieldHelper n={3} value={tachoversion} onChange={this.handleChange('tachoversion')} label="Tachoversion" />
                            <TextFieldHelper n={3} value={kuehlerfrostschutz} onChange={this.handleChange('kuehlerfrostschutz')} label="Kühlerfrostschutz" />
                            <TextFieldHelper n={3} value={farbe} onChange={this.handleChange('farbe')} label="Farbe" />
                        </Grid>

                        <Divider className={"divider"} />

                        <Grid container spacing={8}>
                            <Grid item xs={3}>
                                <Switch
                                    key={wartungsvertrag+"wartungsvertrag"}
                                    checked={wartungsvertrag}
                                    onChange={this.handleChange('wartungsvertrag')}
                                    value="wartungsvertrag"
                                /> Wartungsvertrag
                            </Grid>
                            <Grid item xs={3}>
                                <DatePickerContainer
                                    label="Von"
                                    value={wv_von}
                                    name="wv_von"
                                    onChange={this.handleChange('wv_von')}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <DatePickerContainer
                                    label="Bis"
                                    value={wv_bis}
                                    name="wv_bis"
                                    onChange={this.handleChange('wv_bis')}
                                />
                            </Grid>
                        </Grid>

                        <Divider className={"divider"} />

                        <Grid container spacing={8}>
                            <TextFieldHelper n={3} type="number" value={km_gesamt} onChange={this.handleChange('km_gesamt')} label="Km Gesamt" />
                            <TextFieldHelper n={3} type="number" value={km_pro_jahr} onChange={this.handleChange('km_pro_jahr')} label="Km pro Jahr" />
                            <TextFieldHelper n={3} type="number" value={km_pro_monat} onChange={this.handleChange('km_pro_monat')} label="Km pro Monat" />
                            <TextFieldHelper n={3} type="number" value={wv_stand} onChange={this.handleChange('wv_stand')} label="Aktueller Wv. Stand" />
                        </Grid>

                        <Divider className={"divider"} />

                        <Grid container spacing={8}>
                            <TextFieldHelper multiline n={12} value={notiz} onChange={this.handleChange('notiz')} label="Notiz" />
                        </Grid>

                    </CardContent>
                    <CardActions className="cardAction">
                        <LoaderButton name="Speichern" color="primary" onClick={this.saveAction} loading={this.state.putLoading} />
                    </CardActions>
                </Card>
            </div>
        )
    }

}

const mapStateToProps = state => ({
    fuhrpark: state.fuhrpark,
})

const mapDispatchToProps = (dispatch, ownProps) => ({

    //doPost: (data) => dispatch(doPost("fuhrpark", "api/generic/fuhrpark", data)),
    doLoad: (id) => dispatch(doLoad("fuhrpark", "api/generic/fuhrpark/single/"+id)),
    doDelete: (id) => dispatch(doDelete("fuhrpark", "api/generic/fuhrpark/"+id, id)),
    doPut: (id, data) => dispatch(doPut("fuhrpark", "api/generic/fuhrpark/"+id, data)),

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(FuhrparkDetail));



// WEBPACK FOOTER //
// ./src/Routes/Fuhrpark/Detail.js